// Author: Anmol Rangram

// Hide loader once the page finishes loading
$(window).on('load', function() {
    setTimeout(() => {
        $('.loader').fadeOut(200)
    }, 500);
})

//cick event listener on mobile navigation button to show mobile navigation links
$('.mob-nav').click(function () {
    // add 'open' classes to show mobile navigation
    $('.mob-links').addClass('open')
})

// Click event listener on document
$(document).click(function () {
    // checking wheather the window width is smaller than 992px
    if ($(window).width() < 992) {
        // Verifying wheather the click wasn't made on mobile-nav button or the navigation itself to enable auto close when user clicks on document outside the mentioned elements
        if (!$(event.target).closest('.mob-links,.mob-nav').length) {
            // check wheather the mobile-nav pane is open
            if ($('.mob-links').hasClass('open')) {
                // Disable click events default functionality
                event.preventDefault();
                // remove class open from element mobile-links
                $('.mob-links').removeClass('open')
            }
        }
    }
})
